module.exports = __webpack_public_path__ + "public/files/img/repair.b682ae55.png";